export const APP_NAME = 'DEMO_APP'
export const NAV_MODULE_ICON = {
  tutorial: `navigation/tutorials.svg`,
  faq: `navigation/questions.svg`,
  guide: `navigation/guides.svg`,
  video: `navigation/videos.svg`,
  getStarted: `categories/gettingstarted.svg`,
  home: `categories/home.svg`,
  select: `navigation/select.svg`,
  close: `navigation/close.svg`,
  search: `navigation/search.svg`,
  share: `navigation/share.svg`,
  fb: `navigation/facebook.svg`,
  twitter: `navigation/twitter.svg`,
  copy: `navigation/copy.svg`,
  mail: `navigation/mail.svg`,
  location: `categories/location_sm.svg`,
  person: `categories/person_sm.svg`,
  shopping: `categories/shopping_cart_sm.svg`,
  language: `categories/language_sm.svg`
}

/* Support both UA and GA4 Analytics */
export const ANALYTICS_IDS = ['UA-71383119-2', 'G-9X35D4F9PE']
export const GTM_ID = 'GTM-PCTZF5R'
export const CUSTOM_HEADER_AND_FOOTER_CUSTOMERS = [
  'trial-fe-qa-env',
  'trial-fe-staging-env',
  'trial',
  'stacademy',
  'stacademy-staging',
  'tracfone',
  'tracfone-staging',
  'totalbyverizon',
  'totalbyverizon-staging'
]

export const CUSTOM_GLOBAL_CUSTOMER_VERSION_KEYS = {
  default: 'v1',
  stacademy: 'v2',
  tracfone: 'v3',
  totalbyverizon: 'v4'
}



// WEBPACK FOOTER //
// ./src/constants/index.js